import CollectQRCode from './CollectQRCode'
import RedeemQRCode from './RedeemQRCode'
import CollectQRCodeLot from './CollectQRCodeLot'
import Activity from './Activity'
import ReportActivity from './ReportActivity'
import ReportCode from './ReportCode'
import ReportCoin from './ReportCoin'
import GivePointM from './GivePointM'
import RefundPoint from './RefundPoint'
import VGroupShortcut from './VGroupShortcut'

export default {
  CollectQRCode,
  RedeemQRCode,
  CollectQRCodeLot,
  Activity,
  ReportActivity,
  ReportCode,
  ReportCoin,
  GivePointM,
  RefundPoint,
  VGroupShortcut
}



// WEBPACK FOOTER //
// ./src/components/Tool/index.js